// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul>li[data-v-14cd933e]{list-style:none;padding-inline:3rem;padding-block:.5rem;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;border-bottom:1px solid var(--v-primary-base)}", ""]);
// Exports
module.exports = exports;
